import { render, staticRenderFns } from "./SettingExpertInfo.vue?vue&type=template&id=c74df490&scoped=true&"
import script from "./SettingExpertInfo.vue?vue&type=script&lang=js&"
export * from "./SettingExpertInfo.vue?vue&type=script&lang=js&"
import style0 from "./SettingExpertInfo.vue?vue&type=style&index=0&id=c74df490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74df490",
  null
  
)

export default component.exports